import React, { useEffect, useState } from 'react';
import './ODHomeMostPopularBrands.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getClickCategory } from '../../../../actionCreators/home';
import ButtonOwnDays from '../../../../CommonComponents/buttons/ButtonOwnDays/ButtonOwnDays';
import LazyLoadBackgroundImage from '../../../CommonComponents/LazyLoadBackgroundImage/LazyLoadBackgroundImage';

const ODHomeMostPopularBrands = ({ viewAllBtn = null, brands }) => {
  const clickCategoryData = useSelector(state => state.home?.clickCategory);

  const [clickCategory, setClickCategory] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (clickCategory && clickCategoryData.data && clickCategoryData.data.urlPath) {
      window.location.href = `/sg/en/${clickCategoryData.data.urlPath}`;
    }
  }, [clickCategory, clickCategoryData]);

  const handleShapeClick = catId => {
    setClickCategory(true);
    dispatch(getClickCategory(catId));
  };

  if (brands?.length > 0) {
    return (
      <div className="od-home-mpb">
        <div className="od-home-mpb__content">
          {brands.map((brand, index) => {
            return (
              <div
                key={index}
                className="od-home-mpb__card"
                onClick={() => handleShapeClick(brand?.catId)}
              >
                <LazyLoadBackgroundImage
                  className="od-home-mpb__card__image"
                  src={brand?.img?.src}
                ></LazyLoadBackgroundImage>
              </div>
            );
          })}
        </div>
        {viewAllBtn ? (
          <div className="od-home-bs__bottom">
            <ButtonOwnDays
              fontClass="od-font-reg"
              fontSize="20px"
              mode="oval-grey"
              px="40px"
              py="12px"
              style={{ margin: '0 auto' }}
              text={viewAllBtn.text}
              onClick={() => {}}
            />
          </div>
        ) : null}
      </div>
    );
  }

  return null;
};

export default ODHomeMostPopularBrands;
